__turbopack_context__.v({
  "buttonsWrapper": "f51AwG_buttonsWrapper",
  "deliverySlotSubmitWrapper": "f51AwG_deliverySlotSubmitWrapper",
});
